import * as app from "./app";
import * as asset from "./asset";
import * as assets from "./assets";
import * as auth from "./auth";
import * as axisDeficientAssetUrl from "./axisDeficientAssetUrl";
import * as axisOrder from "./axisOrder";
import * as axisOrders from "./axisOrders";
import * as clipperMovie from "./clipperMovie";
import * as content from "./content";
import * as info from "./info";
import * as keyShortcuts from "./keyShortcuts";
import * as luciPanel from "./luciPanel";
import * as publish from "./publish";
import * as runningOrder from "./runningOrder";
import * as savedItems from "./savedItems";
import * as savedState from "./savedState";
import * as snackbar from "./snackbar";
import * as userInterface from "./userInterface";

export default {
  app,
  asset,
  assets,
  auth,
  axisDeficientAssetUrl,
  axisOrder,
  axisOrders,
  clipperMovie,
  content,
  info,
  keyShortcuts,
  luciPanel,
  publish,
  runningOrder,
  savedItems,
  savedState,
  snackbar,
  userInterface
};



// WEBPACK FOOTER //
// ./app/actions/index.js